// extracted by mini-css-extract-plugin
module.exports = {"container":"MovingPlannerConfirmationCheckbox_container__I8i9p"};